<main>
  <div class="as-row as-justify-sb as-align-center">
    <p class="as-font as-font-20 as-font-bold as-font-black-gray">
      {{
        data.type === 'filters'
          ? ('FILTER.filterBy' | translate)
          : ('FILTER.order' | translate)
      }}
    </p>
    <mat-icon
      mat-dialog-close
      class="as-pointer"
      svgIcon="ic-close-green"
    ></mat-icon>
  </div>

  <p
    *ngIf="data.type !== 'filters'"
    class="as-font as-font-14 as-font-grey-75 as-font-normal"
  >
    {{ 'FILTER.choice' | translate }}
  </p>
  <div class="as-filters-wrapper as-column as-gap-10">
    <p class="as-font-14 as-font-bold">Precio</p>

    <ng-container *ngIf="data.type === 'filters'; else ordersChecks">
      <div class="as-row as-justify-sb as-align-center as-price">
        <mat-form-field appearance="outline" color="accent">
          <mat-label>{{ 'FILTER.from' | translate }}</mat-label>
          <input
            placeholder="$"
            [formControl]="minPriceForm"
            type="number"
            matInput
            [max]="maxPriceForm.value"
            min="0"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" color="accent">
          <mat-label>{{ 'FILTER.until' | translate }}</mat-label>
          <input
            placeholder="$"
            [min]="minPriceForm.value"
            [formControl]="maxPriceForm"
            type="number"
            matInput
          />
        </mat-form-field>
      </div>

      @if(from !=='carrousel'){
      <div class="as-column as-gap-10">
        <p class="as-font as-font-semibold as-black as-font-14">
          {{ 'FILTER.offers' | translate }}
        </p>
        <mat-checkbox
          [checked]="filters.promotion"
          (change)="filterPromotion($event)"
        >
          <mat-label class="as-font as-font-grey-75 as-font-14">{{
            'FILTER.onPromotion' | translate
          }}</mat-label>
        </mat-checkbox>
      </div>
      }

      <div class="as-column as-gap-10">
        <p class="as-font as-font-semibold as-black as-font-14">
          {{ 'FILTER.categories' | translate }}
        </p>
        <div class="as-column as-gap-5">
          <mat-checkbox
            [checked]="subCategory.checked"
            *ngFor="let subCategory of subCategories; let i = index"
            (change)="
              from === 'carrousel'
                ? filterSubCategoryCarrousel(subCategory.subcategory, i, $event)
                : filterSubCategory(subCategory)
            "
          >
            <mat-label class="as-font as-font-grey-75 as-font-14">
              {{ subCategory.subcategory | titlecase }} ({{
                subCategory.results || subCategory.total
              }})
            </mat-label>
          </mat-checkbox>
        </div>
      </div>

      <div>
        <p class="as-font as-font-semibold as-black as-font-14">
          {{ 'FILTER.brand' | translate }}
        </p>
        <div class="as-column as-gap-5">
          <mat-checkbox
            [checked]="brand.checked"
            *ngFor="let brand of brands; let i = index"
            (change)="filterBrand(brand.brand, i, $event)"
          >
            <mat-label class="as-font as-font-grey-75 as-font-14">
              {{ brand.brand | titlecase }}
              ({{ brand.results || brand.total }})
            </mat-label>
          </mat-checkbox>
        </div>
      </div>
    </ng-container>
    <ng-template #ordersChecks>
      <div class="as-column as-gap-10 as-price-wrapper">
        <mat-radio-group
          aria-labelledby="example-radio-group-label"
          class="as-column as-gap-10"
          [(ngModel)]="optionSelected"
        >
          <mat-radio-button
            *ngFor="let radio of orderList"
            [value]="radio"
            (change)="selectOrder(radio)"
          >
            <p class="as-font as-font-grey-75 as-font-14">
              {{ radio.label }}
            </p>
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </ng-template>
  </div>

  <div class="as-buttons as-column as-gap-10">
    <ng-container *ngIf="data.type === 'filters'">
      <button (click)="applyFilters()" mat-flat-button color="accent">
        <mat-label class="as-font">Aplicar filtros</mat-label>
      </button>
      <button (click)="clearFilters()" mat-stroked-button color="accent">
        <mat-label class="as-font">Limpiar filtros</mat-label>
      </button>
    </ng-container>
  </div>
</main>
